import React from 'react';
import './footer.css'
import linkedin from './iconmonstr-linkedin-4.svg';
import github from './iconmonstr-github-4.svg';
import twitter from './iconmonstr-twitter-4.svg';

export const Footer = ({isBackgroundTransparent}) => {
  let fadeBackground = (isBackgroundTransparent)?'fadeToTransparent':'fadeToBlack';
  return (
    <footer className={`fixed-bottom + ${fadeBackground}`}>
      <p className="d-none d-md-block">“Happiness is when what you think, what you say, and what you do are in harmony.” – Mahatma Gandhi</p>
      <div className="right">
        <a href="https://www.linkedin.com/in/mikelwitt" target="_blank" rel="noopener noreferrer"><img src={linkedin} alt="Linkedin 4" width="50"
                                                                             height="50"/></a>
        <a href="https://github.com/nohona/" target="_blank" rel="noopener noreferrer"><img src={github} alt="Linkedin 4" width="50" height="50"/></a>
        <a href="https://twitter.com/Nohona" target="_blank" rel="noopener noreferrer"><img src={twitter} alt="Linkedin 4" width="50"
                                                                  height="50"/></a>
      </div>
    </footer>
  );
};



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js